module.exports = "<section class=\"app-pages app-upload-treatment\" [ngClass]=\"{'d-mode': !!isDarkTheme}\">\r\n  <router-outlet></router-outlet>\r\n</section>"